// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nameList[data-v-24b7f176]{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden}.btn[data-v-24b7f176]{margin:5px 0}.multifields div[data-v-24b7f176]{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
